import clsx from 'clsx'
import { Link, useLocation } from 'react-router-dom'
import { useLayout } from '../../../core'
import { usePageData } from '../../../core/PageData'

/**
 * Shared industry pattern for both admin apps:
 *   Dashboard › Current page     (breadcrumb / orientation)
 *   # Current page               (H1 landmark — on by default via PageTitle showHeading)
 *
 * Routes opt out of the shared H1 with <PageTitle showHeading={false}> when the
 * page needs a custom/dynamic inline title (use AdminPageHeader for that row).
 */
const PageTitle = () => {
  const { pageTitle, pageDescription, pageShowHeading } = usePageData()
  const location = useLocation()
  const { config, classes } = useLayout()
  const appPageTitleDirection = config.app?.pageTitle?.direction

  const isDashboardRoute =
    location.pathname === '/dashboard' || location.pathname === '/'

  const showBreadcrumb =
    !!config.app?.pageTitle?.breadCrumb && !isDashboardRoute && !!pageTitle

  const showHeading =
    !!config.app?.pageTitle?.display &&
    !isDashboardRoute &&
    !!pageTitle &&
    !!pageShowHeading

  const swapperParent =
    "{default: '#kt_app_content_container', 'lg': '#kt_app_content_container'}"

  if (!showBreadcrumb && !showHeading) {
    return (
      <div
        id="kt_page_title"
        data-kt-swapper="true"
        data-kt-swapper-mode="prepend"
        data-kt-swapper-parent={swapperParent}
        className="page-title d-none"
        aria-hidden="true"
      />
    )
  }

  return (
    <div
      id="kt_page_title"
      data-kt-swapper="true"
      data-kt-swapper-mode="prepend"
      data-kt-swapper-parent={swapperParent}
      data-admin-has-heading={showHeading ? '1' : '0'}
      className={clsx(
        'page-title d-flex flex-column flex-wrap w-100',
        classes.pageTitle.join(' '),
        config.app?.pageTitle?.class,
        {
          'justify-content-center': appPageTitleDirection === 'column',
        }
      )}
    >
      {showBreadcrumb && (
        <nav className="kt-breadcrumb-nav d-flex" aria-label="Breadcrumb">
          <ol className="breadcrumb mb-0 kt-breadcrumb align-items-center">
            <li className="breadcrumb-item">
              <Link
                to="/dashboard"
                className="text-gray-500 text-hover-primary d-flex align-items-center"
              >
                <i
                  className="bi bi-arrow-left-short pe-0 fs-26"
                  aria-hidden="true"
                />
                <span className="d-none d-sm-inline fs-18">Dashboard</span>
              </Link>
            </li>
            <li className="breadcrumb-item active" aria-current="page">
              <span className="text-gray-700 fw-semibold fs-18">{pageTitle}</span>
            </li>
          </ol>
        </nav>
      )}

      {showHeading && (
        <h1 className="page-heading fs-3 fw-bold mb-0">{pageTitle}</h1>
      )}

      {showHeading && pageDescription ? (
        <div className="page-desc text-muted mt-1">{pageDescription}</div>
      ) : null}
    </div>
  )
}

export { PageTitle }
